import React, { useRef, useEffect, useState } from 'react';
import Video from "twilio-video";
import Room from "./Room.jsx";
import VideoPreview from "./VideoPreview.jsx";
import useDevices from "./useDevices.jsx";

const ReactTwilioVideoContainer = (props) => {
	const [room, setRoom] = useState(null);
	const [connecting, setConnecting] = useState(false);

	const { audioInputDevices } = useDevices();
	const { videoInputDevices } = useDevices();

	const login = (loginInfo) => {
		console.log(loginInfo);

		fetch(`${props.tokenApi}?identity=${loginInfo.identity}&roomName=${loginInfo.roomName}`)
		.then((response) => Promise.resolve(response))
		.then((response) => response.json())
		.then((res) => {
			console.log(res);
			Video.createLocalAudioTrack().then((audioTrack) => {
				console.log(audioTrack);
			});
			Video.createLocalVideoTrack().then((videoTrack) => {
				console.log(videoTrack);
			});

			Video.connect(res.token, {
			})
			.then((room) => {
				setConnecting(true);
				console.log(room);
				setRoom(room);
			})
			.catch((err) => {
				console.error(err);
				setConnecting(false);
			});
		})
	}

	useEffect(() => {

	}, []);

	return (
		<div>
			{
				!connecting &&
				<VideoPreview login={login} />
			}

			{audioInputDevices.length >= 1 ?
			(
				<div>
					<h4>audio options</h4>
					{audioInputDevices.map(device => (
						<div value={device.deviceId} key={device.deviceId}>
							{device.label}
						</div>
					))}
				</div>
			)
			: (
				<div>no audio input</div>
			)}

			{videoInputDevices.length >= 1 ?
			(
				<div>
					<h4>video options</h4>
					{videoInputDevices.map(device => (
						<div value={device.deviceId} key={device.deviceId}>
							{device.label}
						</div>
					))}
				</div>
			)
			: (
				<div>no video input</div>
			)}

			{
				room && connecting &&
				<Room roomName={room.name} room={room} handleLogout={() => {}} />
			}
		</div>
	);
}

export default ReactTwilioVideoContainer;
